import { render, staticRenderFns } from "./InputCargo.vue?vue&type=template&id=258d3a66&"
import script from "./InputCargo.vue?vue&type=script&lang=js&"
export * from "./InputCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports